import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import rectangleIcon from "../Elements/icons/rectangleIcon";

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    options: {
      customProperties: true,
    },
    themes: {
      light: {
        primary: '#1565c0',
        primary_light: '#7F9ED3',
        secondary: '#48cbf9',
        error: '#FE6868',
        field_background: '#F4F7FC',
        gray:'#A5B0BE'
      },
      dark: {
        primary: '#1565c0',
            primary_light: '#7F9ED3',
        secondary: '#CFF3',
        error: '#FE6868',
        field_background: '#F4F7FC',
        gray:'#A5B0BE'
      },
    },
  },
   icons: {
     values: {
       rectangle: {
         component: rectangleIcon,
       }
     }
   }
});





// WEBPACK FOOTER //
// ./src/plugins/vuetify.js